let urlPersistenceSuppressed = false;

/**
 * Temporarily suppress URL persistence writes (replaceState calls).
 * Store mutations during the callback update Zustand in-memory state
 * but do not overwrite the current browser history entry.
 * This is used when navigating away from a page that needs its
 * history entry preserved for back-button navigation.
 */
export function withSuppressedUrlPersistence(fn: () => void): void {
  urlPersistenceSuppressed = true;
  try {
    fn();
  } finally {
    urlPersistenceSuppressed = false;
  }
}

const getSearchParams = () => new URL(window.location.href).searchParams;

const updateSearchParams = (searchParams: URLSearchParams) => {
  if (urlPersistenceSuppressed) return;
  window.history.replaceState({}, '', `${window.location.pathname}?${searchParams.toString()}`);
};

const getSearchParam = (key: string) => {
  const searchParams = getSearchParams();
  return searchParams.get(key);
};

const updateSearchParam = (key: string, value: string) => {
  const searchParams = getSearchParams();
  searchParams.set(key, value);

  updateSearchParams(searchParams);
};

const removeSearchParam = (key: string) => {
  const searchParams = getSearchParams();
  searchParams.delete(key);

  updateSearchParams(searchParams);
};

export const searchParamsStorage = {
  getItem: (key: string) => getSearchParam(key),
  setItem: (key: string, value: string) => updateSearchParam(key, value),
  removeItem: (key: string) => removeSearchParam(key),
};
